import { CredentialField } from './CredentialField'
import { useState, type FormEvent } from 'react'
import { ButtonLink, Button, Icon } from 'admination-react'
import { resetPassword } from '@/core/api/auth'
import {
  PASSWORD_MISMATCH,
  PASSWORD_MISSING,
  RESET_DONE,
  RESET_LINK_INVALID,
  passwordPolicyMessage,
  tooManyAttemptsMessage,
} from './messages'

export function ResetPassword({ token }: { token: string | null }) {
  const [passwort, setPasswort] = useState('')
  const [wiederholung, setWiederholung] = useState('')
  const [busy, setBusy] = useState(false)
  const [done, setDone] = useState(false)
  const [error, setError] = useState<string | null>(token ? null : RESET_LINK_INVALID)

  async function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault()
    if (busy) return
    if (!token) {
      setError(RESET_LINK_INVALID)
      return
    }
    if (!passwort || !wiederholung) {
      setError(PASSWORD_MISSING)
      return
    }
    if (passwort !== wiederholung) {
      setError(PASSWORD_MISMATCH)
      return
    }
    setBusy(true)
    setError(null)
    try {
      await resetPassword(token, passwort)
      setPasswort('')
      setWiederholung('')
      setDone(true)
    } catch (err) {
      setError(tooManyAttemptsMessage(err) ?? passwordPolicyMessage(err) ?? RESET_LINK_INVALID)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="page" id="page">
      <div className="layout layout--center" id="base-layout">
        <main className="form form--narrow">
          <div className="section">
            <h3 className="section-header">Passwort zurücksetzen</h3>
            <div className="section-body">
              {done ? (
                <p role="status">
                  {RESET_DONE}
                </p>
              ) : (
                <form onSubmit={(e) => void submit(e)} noValidate className="section-body">
                  <CredentialField label="Neues Passwort" id="reset-password" name="new-password" type="password"
                    autoComplete="new-password" value={passwort} onChange={setPasswort}
                    disabled={busy || !token} />
                  <CredentialField label="Neues Passwort wiederholen" id="reset-password-repeat" name="new-password-repeat" type="password"
                    autoComplete="new-password" value={wiederholung} onChange={setWiederholung}
                    disabled={busy || !token} />
                  <Button type="submit" variant="primary" block loading={busy} disabled={!token}>
                    <Icon name="i-check" />Passwort speichern</Button>
                </form>
              )}
              {error && (
                <p role="alert" className="field-error">
                  {error}
                </p>
              )}
              <ButtonLink block href="/">
                Zur Anmeldung</ButtonLink>
            </div>
          </div>
        </main>
      </div>
    </div>
  )
}
